import {
  ResforFactory,
  ResforData,
  ResforFactoryError,
  ResforCode,
  ResforNif,
  ResforYear,
  ResforEmail,
  ResforPhone,
  PostalCode,
  ResforName,
  ResforAddress
} from '@/Domain/Resfor'
import { AxiosResforResponse } from './AxiosResforResponse'
import { ProvinceCode } from '@/Domain/Localization/Province'
import { CountyCode } from '@/Domain/Localization/County'
import { ParishCode } from '@/Domain/Localization/Parish'
import { PlaceCode } from '@/Domain/Localization/Place'

export class AxiosResforFactory implements ResforFactory<AxiosResforResponse> {
  makeResforData (data: AxiosResforResponse): ResforData {
    try {
      const email = data.email ? new ResforEmail(data.email) : null
      const phone = data.tlf1 ? new ResforPhone(data.tlf1) : null
      const fax = data.fax ? new ResforPhone(data.fax) : null
      const mobile = data.tlf2 ? new ResforPhone(data.tlf2) : null
      const proviceCode = data.codprovincia ? new ProvinceCode(data.codprovincia) : null
      const countyCode = data.codconcello ? new CountyCode(data.codconcello) : null
      const parishCode = data.idparroquia ? new ParishCode(data.idparroquia) : null
      const placeCode = data.lugar ? new PlaceCode(data.lugar) : null
      const postalCode = data.cp ? new PostalCode(data.cp) : null
      const resforName = data.nome ? new ResforName(data.nome) : null
      const resforAddress = data.direccion ? new ResforAddress(data.direccion) : null
      return new ResforData(
        new ResforCode(data.numResfor),
        new ResforNif(data.nif),
        new ResforYear(data.ultimoAnyo),
        resforName,
        email,
        phone,
        fax,
        mobile,
        proviceCode,
        countyCode,
        parishCode,
        placeCode,
        postalCode,
        resforAddress
      )
    } catch (error) {
      throw new ResforFactoryError(error.message)
    }
  }
}
